module.exports = __webpack_public_path__ + "img/choose.ab4d79c8.svg";